import(/* webpackMode: "eager" */ "/app/src/app/(main)/chinh-sach-van-chuyen/page.tsx");
